import { URLS } from "../../../utils/urls";
import { Navigate } from "react-router-dom";
import { isChkEstimateCookieData, isChkReservationCookieData } from "../../../lib/Util";

function CookieCheck() {
    if (!isChkEstimateCookieData()) {
        alert('잘못된 접근입니다.\n상품 소개 화면에서 \n기본정보를 다시 입력해주세요.')
        return false
    }
    return true
}


export const ProtectedRouteMm = ({ children }) => {
    const isLoggedIn = CookieCheck()
    if (!isLoggedIn) {
        window.location.href = process.env.REACT_APP_BOOKING_LOGIN_URL
        return <></>

    }
    return children
}